import React from "react";

import { useAppSelector } from "../../app/hooks";
import { getIsImgModalOpen } from "../../features/settings/settingsSlice";
import ImgModal from "../modals/ImgModal";
import Footer from "./Footer";
import Header from "./Header";
import PinLockScreen from "./PinLockScreen";
import useLayoutBootstrap from "./useLayoutBootstrap";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const AppLayout = ({ children, className }: Props) => {
  const isImgModalOpen = useAppSelector(getIsImgModalOpen);

  useLayoutBootstrap();

  return (
    <div
      className={`font-inter relative flex min-h-screen w-full flex-col bg-white text-[hsl(222_84%_5%)] ${
        className || ""
      }`}
    >
      <Header />

      <main
        className={`flex flex-1 flex-col mt-14 md:mt-16 gap-2 p-3 md:gap-4 md:p-6 ${
          isImgModalOpen ? "bg-primary-2 opacity-20" : ""
        }`}
      >
        {children}
      </main>

      <Footer />

      <ImgModal />

      <PinLockScreen />
    </div>
  );
};
export default AppLayout;
